<template #default>
    <div>
        <div class="mb-0">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-information-outline mr-1"></i>
                Basic Information
            </h6>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Event</small>
                    <b-badge :variant="getEventVariant(activityLog.event)">{{ activityLog.event || '--' }}</b-badge>
                </div>
                <div class="col-md-6 mb-3"></div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">User</small>
                    <div class="border rounded bg-light p-2">{{ getUserName(activityLog.user) }}</div>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">{{ $t('label.createdAt') }}</small>
                    <div class="border rounded bg-light p-2">{{ activityLog.createdAt || '--' }}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-text-box-outline mr-1"></i>
                Description
            </h6>
            <div class="border rounded bg-light p-2 text-primary">{{ activityLog.description || '--' }}</div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-text-short mr-1"></i>
                Subject
            </h6>
            <div class="row">
                <div class="col-md-6">
                    <small class="text-muted d-block mb-1">Subject Type</small>
                    <div class="border rounded bg-light p-2">{{ activityLog.subjectType || '--' }}</div>
                </div>
                <div class="col-md-6">
                    <small class="text-muted d-block mb-1">Causer Type</small>
                    <div class="border rounded bg-light p-2">{{ activityLog.causerType || '--' }}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-speedometer mr-1"></i>
                Performance
            </h6>
            <div
                v-if="activityLog.performance"
                class="table-responsive"
            >
                <table class="table table-sm table-bordered mb-0">
                    <tbody>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Memory Current</td>
                            <td>{{ activityLog.performance.memoryCurrentMb || '--' }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Memory Peak</td>
                            <td>{{ activityLog.performance.memoryPeakMb || '--' }}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold text-muted text-nowrap">Duration</td>
                            <td>{{ activityLog.performance.duration_ms || '--' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span v-else>--</span>
        </div>
        <hr>
        <div class="mb-4">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-history mr-1"></i>
                Old Values
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ activityLog.oldValues ? getJsonText(activityLog.oldValues) : '--' }}</pre>
            </div>
        </div>
        <div class="mb-4">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-history mr-1"></i>
                New Values
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ activityLog.newValues ? getJsonText(activityLog.newValues) : '--' }}</pre>
            </div>
        </div>
        <div class="mb-4">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-code-json mr-1"></i>
                Properties
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ activityLog.properties ? getJsonText(activityLog.properties) : '--' }}</pre>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end">
            <b-button
                type="button"
                variant="danger"
                class="col-2"
                @click="$emit('done')"
            >
                {{ $t('label.cancel') }}
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        activityLog: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getJsonText(data) {
            if (typeof data == 'string') return data;
            return JSON.stringify(data, null, 2);
        },
        getUserName(user) {
            if(!user) return '--';
            return `${user.firstName} ${user.lastName}`;
        },
        getEventVariant(event) {
            if(event == 'created') return 'success';
            if(event == 'updated') return 'warning';
            if(event == 'deleted') return 'danger';
            return 'secondary';
        },
    },
}
</script>
